import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { BalanceService } from 'src/app/services/balance.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { PasarelaPagoComponent } from 'src/app/pages/vista-compra/components-compra/pasarela-pago/pasarela-pago.component';
import { UiServices } from 'src/app/services/ui-services';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from 'src/app/services/http.service';
import { InscriptionService } from 'src/app/services/inscription.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-inscription-detail',
  templateUrl: './inscription-detail.component.html',
  styleUrls: ['./inscription-detail.component.scss'],
})
export class InscriptionDetailComponent implements OnInit, OnDestroy {
  @Input() set inscriptionData(value) {
    this.inscription = undefined;
    if (value) {
      this.setInscription(value);
    }
  }
  public inscription = undefined;
  public testImg = environment.defaultImg;
  public currencyName = 'USD';
  public currency = undefined;
  public status = false;
  public msgBtn = '';
  private balanceObs: Subscription = new Subscription();

  constructor(
    private balanceSv: BalanceService,
    private uiSv: UiServices,
    private trSv: TranslateService,
    private httpSv: HttpService,
    private inscriptionSv: InscriptionService,
    private route: ActivatedRoute
  ) {}

  async ngOnInit() {
    if (this.balanceSv.currency) {
      this.setCurrency(this.balanceSv.currency);
    } else {
      this.balanceObs = this.balanceSv.currencySource.subscribe((currency) => {
        this.setCurrency(currency);
      });
    }
    const inscriptionId = this.route.snapshot.queryParamMap.get('id');
    if (inscriptionId) {
      const res = await this.httpSv.itemIndex(
        'client/inscription',
        '',
        { id: inscriptionId },
        `show`
      );
      res.data.description = res.data?.subscription?.description || '';
      res.data.media = res.data?.subscription?.media || [];
      this.setInscription(res.data);
    }
  }

  setInscription(value) {
    if (value.status === 'Pagado') {
      const txt = this.trSv.instant('EN_ESPERA_DE_APROBACION');
      this.setBtnData(true, txt);
    } else if (value.status === 'Aprobado') {
      const canRenovate = new Date(value.renovation);
      const actualDate = new Date();
      if (canRenovate <= actualDate) {
        this.setBtnData(false, '');
      } else {
        const txt = this.trSv.instant('SUSCRIPCION_ACTIVA');
        this.setBtnData(true, txt);
      }
    } else {
      this.setBtnData(false, '');
    }
    setTimeout(() => {
      this.inscription = value;
    });
  }

  setCurrency(currency) {
    this.currency = currency;
    this.currencyName = currency?.symbol || this.balanceSv.currencyBaseName;
  }

  async setRenovation(ev) {
    try {
      const data = ev as CustomEvent<HTMLIonCheckboxElement>;
      const value = data.detail.checked;
      const res = await this.httpSv.itemAction(
        {
          id: this.inscription?.inscriptionId || this.inscription?.id,
          type: value,
        },
        'client/inscription',
        'autoRenovation'
      );
      if (res.status) {
        const msg = this.trSv.instant('GUARDADO_EXITOSAMENE');
        this.uiSv.showToast(msg);
      }
      this.inscriptionSv.emitReload.emit();
    } catch (err) {
      console.error(err);
    }
  }

  setBtnData(status, msg) {
    this.status = status;
    this.msgBtn = msg;
  }

  ngOnDestroy(): void {
    this.balanceObs.unsubscribe();
  }

  async renew() {
    const price = this.inscription.promotionalPrice || this.inscription.price;
    this.inscription.reason = 'renew';
    this.inscription.isClient = true;
    const res = await this.uiSv.showModal(
      PasarelaPagoComponent,
      { goPayment: true, payment: price, transactionData: this.inscription },
      'pasarela-pago'
    );
    if (res.data?.text === 'sended') {
      const tr = this.trSv.instant(
        'SU_RENOVACION_SE_ENCUENTRA_EN_REVICION_PRONTO_LE_ENVIAREMOS_UN_CORREO'
      );
      this.uiSv.showToast(tr);
    }
    this.inscriptionSv.emitReload.emit();
  }
}
